// @ts-nocheck

import googlePlacesFieldAutocomplete from 'root/helpers/googlePlacesFieldAutocomplete';

const handleGooglePlacesFieldAutocomplete = (fieldObjects, inputName, callback) => {
    const matchedInput = fieldObjects.find(
        fieldObject => fieldObject.field.name === inputName
    )?.field;
    if (matchedInput) {
        if (inputName === 'zip' && matchedInput.dataset.googlePlacesField !== 'true') {
            return;
        }
        const googlePlacesInstance = googlePlacesFieldAutocomplete(
            matchedInput,
            callback
        );

        // this is a fallback in case the field was autofilled, if the user used autofill this will be triggered
        // and the autofilled input text will be sent as is as the value of the street key in the data attribute object.
        matchedInput.addEventListener('blur', () => {
            if (!matchedInput.hasAttribute(`data-leadform-${inputName}`)) {
                callback(matchedInput, null);
            }
        });

        matchedInput.addEventListener('focus', () => googlePlacesInstance.init());
    }
};

const setDataAttributeForAddress = (input, googlePlacesObjectsArray) => {
    // This object's keys are specific to Kounta's platform
    // We are mapping Google's places api to this object
    // and providing a fallback (else if) in case the user entered the address manually
    const addressObj = { street: '', suburb: '', state: '', postcode: '' };
    const streetArr = [];
    if (googlePlacesObjectsArray) {
        googlePlacesObjectsArray.forEach(field => {
            if (field.types.includes('street_number') && field.long_name) {
                streetArr.push(field.long_name);
            }
            if (field.types.includes('route') && field.long_name) {
                streetArr.push(field.long_name);
            }
            if (streetArr.length > 0) {
                addressObj.street = streetArr.join(', ');
            }
            if (field.types.includes('locality') && field.long_name) {
                addressObj.suburb = field.long_name;
            }
            if (field.types.includes('administrative_area_level_1') && field.long_name) {
                addressObj.state = field.long_name;
            }
            if (field.types.includes('postal_code') && field.long_name) {
                addressObj.postcode = field.long_name;
            }
        });
    } else if (input.value) {
        addressObj.street = input.value;
    }
    // Set the data attribute with the stringified JSON as the value
    input.setAttribute('data-leadform-address', JSON.stringify(addressObj));
};

const setDataAttributeForZipCode = (input, googlePlacesObjectsArray) => {
    let zipCode = 'no-zipcode-provided';
    if (googlePlacesObjectsArray) {
        googlePlacesObjectsArray.forEach(field => {
            if (field.types.includes('postal_code')) {
                /* As per google docs - https://developers.google.com/places/web-service/details#PlaceDetailsResults:
                    long_name is the full text description or name of the address component as returned by the Geocoder. Ex:
                    "long_name":"United States",
                    "short_name":"US"
                    */
                /*There's no example provided for the postal code (or zipCode) long_name or short_name. I am sending the long_name anyway so that if it's applicable we will get as much details as possible.*/
                zipCode = field.long_name;
            }
        });
    } else if (input.value) {
        zipCode = input.value;
    }
    input.setAttribute('data-leadform-zip', zipCode);
};

export {
    handleGooglePlacesFieldAutocomplete,
    setDataAttributeForAddress,
    setDataAttributeForZipCode,
};
